<template>
<CRow>
    <CCol col="12">
        <p>بعد از پیاده‌سازی اسکریپت از طریق لینک (<CLink :href="affLink" target="_blank">انجام خرید تست</CLink>) وارد سایت خود شوید و یک خرید انجام دهید بعد از انجام خرید روی دکمه بررسی خرید کلیک کنید.</p>
    </CCol>
    <CCol col="12">
        <CButton @click="check" class="btn btn-affili-cerise btn-md w-100">بررسی خرید</CButton>
    </CCol>
    <CCol col="12" class="mt-3" v-if="Object.keys(testConversionData).length > 0 && checked">
        <div class="position-relative table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>شماره پیگیری</th>
                        <th>مقدار سبد خرید</th>
                        <th>کمیسیون‌ها</th>
                        <th>کد تخفیف</th>
                    </tr>
                </thead>
                <tbody class="position-relative">
                    <tr>
                        <td>{{ testConversionData.external_id }}</td>
                        <td>{{ $numberWithCommas(testConversionData.amount) }}</td>
                        <td>{{ testConversionData.commissions && testConversionData.commissions.map(e => e.name).join(',') }}</td>
                        <td>{{ testConversionData.coupon }}</td>
                    </tr>
                </tbody>
            </table>
            <p class="alert alert-warning">در صورتی که داده‌های نمایش داده شده درست است یعنی اسکریپت به درستی پیاده سازی شده و می‌توانید به مرحله بعد بروید.</p>
        </div>
    </CCol>
    <CCol col="12" class="mt-3" v-else-if="Object.keys(testConversionData).length == 0 && checked">
        <div class="alert alert-warning">
            <p class="font-lg">اطلاعات خرید تست را دریافت نکردیم.</p>
            <ul>
                <li>مطمئن شوید که فرآیند خرید را به صورت کامل طی کرده‌اید. افیلی تنها خرید‌هایی را ردیابی می‌کند که به صفحه <span class="text-danger bg-gray-100 font-sm p-1">thank you page</span> رسیده باشند.</li>
                <li>ممکن است اسکریپت به درستی پیاده‌سازی نشده باشد.</li>
            </ul>
        </div>
    </CCol>
</CRow>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getFirstOfArray } from '@/common/arrays'
import { toBase64 } from 'js-base64'
import { storeService } from '@/services/api'

export default {
    name: 'TestScript',

    data() {
        return {
            checked: false,
        }
    },

    computed: {
        ...mapGetters({
            store: 'store/firstStore'
        }),
        affLink() {
            if (!this.store.website) {
                return '#'
            }

            let url = new URL(this.store.website)
            url.searchParams.set('referrer', toBase64('affilitest'+this.store.id))
            url.searchParams.set('aff_id', 'affilitest'+this.store.id)

            return url.href
        },
        testConversionData() {
            return this.store.test_conversion_data || {}
        }
    },

    methods: {
        ...mapActions({
            testConversion: 'store/testConversion'
        }),
        check() {
            this.testConversion(this.store.id).then(result => {
                this.testData = result.data
                this.checked = true
            })
        },
    }
}
</script>